export default __webpack_public_path__ + "static/media/message-sound.0457746c.wav";